import AircallNumbers from '../collections/AircallNumbers';
import { baseApi } from 'core/api';
import { useToastStore } from 'store/modules';

const state = () => ({
    _items: [],
    _savedItems: [],
    _allNumbers: [],
    _item: null,
    _loading: false,
    _loadingError: false,
    _numbersTotal: 0,
    _settingsLink: '',
    _pagination: null,
    _parameters: {
        page: 1,
        limit: 10,
        numberId: null,
        query: '',
        ids: null,
    },
});

const getters = {
    aircallNumbers: (state) => state._items,
    savedAircallNumbers: (state) => state._savedItems,
    allAircallNumbers: (state) => state._allNumbers,
    aircallNumbersTotal: (state) => state._numbersTotal,
    aircallNumber: (state) => state._item,
    aircallLoading: (state) => state._loading,
    aircallLoadingError: (state) => state._loadingError,
    aircallSettingsLink: (state) => state._settingsLink,
    aircallNumbersParameters: (state) => state._parameters,
    aircallNumbersPagination: (state) => state._pagination,
};

const actions = {
    getAllAircallNumbers() {
        return baseApi
            .get('core/aircall/all-numbers')
            .then((response) => {
                this._setAllAircallNumbersLoaded({
                    numbers: response.data.data,
                });
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error.message,
                });
            });
    },

    getAircallNumbers(payload) {
        if (this._loading) return;

        this._setAircallNumbersLoad();
        this._setAircallNumbersUpdateParams(payload);

        return baseApi
            .get('core/aircall/numbers', { params: this._parameters })
            .then((response) => {
                this._setAircallNumbersLoaded({
                    numbers: response.data.data,
                    total: response.data.meta.total,
                    meta: response.data.meta,
                });
            })
            .catch((error) => {
                this._setAircallNumbersLoadError(error);
            });
    },

    updateAircallNumbersByIdCheck(id) {
        return baseApi
            .post(`core/aircall/numbers/${id}/check`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error?.response?.data['number'],
                });
            });
    },

    updateAircallNumbersByIdAssign({ id, params }) {
        return baseApi.post(`core/aircall/numbers/${id}/assign`, params).then((response) => {
            return response.data;
        });
    },

    aircallChooseNumber(item) {
        this._setAircallNumberChoose(item);
    },

    aircallChooseResetNumber() {
        this._setAircallNumberChooseReset();
    },

    aircallResetNumbersToDefault() {
        this._setAircallResetNumbersToDefault();
    },

    getAircallSettingsLink() {
        return baseApi
            .get('core/aircall/integration/link')
            .then((response) => {
                this._setAircallSettingsLinkLoaded({
                    link: response.data,
                });
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: error.message,
                });
            });
    },

    aircallResetPagination() {
        this._setAircallResetPagination();
    },

    aircallResetParams() {
        this._setAircallNumbersUpdateParams({
            page: 1,
            limit: 10,
            numberId: null,
            query: '',
            ids: null,
        });
    },

    // Private methods
    _setAircallResetNumbersToDefault() {
        this._items = this._savedItems;
    },

    _setAircallNumbersLoad() {
        this._loading = true;
        this._loadingError = false;
    },

    _setAircallNumbersUpdateParams(data) {
        if (data) {
            this._parameters.page = data.page ?? this._parameters.page;
            this._parameters.limit = data.limit ?? this._parameters.limit;
            this._parameters.numberId = data.numberId ?? this._parameters.numberId;
            this._parameters.query = data.query ?? this._parameters.query;
            this._parameters.ids = data.ids ?? this._parameters.ids;
        }
    },

    _setAircallNumbersLoaded({ numbers, total, meta }) {
        numbers = new AircallNumbers(numbers);

        if (!this._savedItems.length || this._savedItems.length < numbers.length) {
            this._savedItems = numbers.models;
        }

        this._loading = false;
        this._loadingError = false;
        this._items = numbers.models;
        this._numbersTotal = total;

        const from =
            meta.current_page === 1
                ? meta.current_page
                : meta.per_page * (meta.current_page - 1) + 1;
        const to = meta.current_page * meta.per_page;

        this._pagination = {
            current_page: meta.current_page,
            from: from,
            last_page: Math.ceil(meta.total / meta.per_page),
            per_page: meta.per_page,
            to: to > meta.total ? meta.total : to,
            total: meta.total,
        };
    },

    _setAircallResetPagination() {
        this._pagination = null;
    },

    _setAllAircallNumbersLoaded({ numbers }) {
        this._allNumbers = numbers;
    },

    _setAircallNumbersLoadError() {
        this._loading = false;
        this._loadingError = true;
        this._items = [];
        this._numbersTotal = 0;
    },

    _setAircallNumberChoose(item) {
        this._item = item;
    },

    _setAircallNumberChooseReset() {
        this._item = null;
    },

    _setAircallSettingsLinkLoaded({ link }) {
        this._settingsLink = link;
    },
};

export default {
    state,
    getters,
    actions,
};
